import SessionsRequest from '../SessionsRequest';
import { Method, SessionsTag } from '../../common/Constants';
import Log from '../../common/log';
import CommonGetters from '../../common/CommonGetters';
/**
 * Handles request creation and dispatching to the request handler
 */
export default class RequestDispatcher {
    constructor(core, options, requestBuilder, requestHandler, sessionContext) {
        this.core = core;
        this.options = options;
        this.requestBuilder = requestBuilder;
        this.requestHandler = requestHandler;
        this.sessionContext = sessionContext;
    }
    /**
     * Dispatch a request to the handler
     * @param service - Service type
     * @param params - Request parameters
     * @param force - Force send even if session state doesn't allow
     * @param onSuccess - Success callback
     * @param onFail - Failure callback
     */
    dispatch(service, params, force, onSuccess, onFail) {
        if (this.core.isUsingLegacy()) {
            return;
        }
        // Build params with RequestBuilder
        params = this.requestBuilder.buildParams(params, service, [this.sessionContext, new CommonGetters(this.options)]);
        // Check params and send session request
        if (params !== null && this.options.enabled) {
            const request = new SessionsRequest(service, params, undefined, force, onSuccess, onFail);
            if (this.isMethodPostEnabled()) {
                request.setMethod(Method.POST);
            }
            this.requestHandler.queueRequest(request);
        }
        else {
            Log.warn(SessionsTag, 'Cannot send session request since either params are not available or options are disabled');
            onFail === null || onFail === void 0 ? void 0 : onFail();
        }
    }
    /**
     * Check if POST method is enabled
     */
    isMethodPostEnabled() {
        return this.options.method && this.options.method.toUpperCase() === 'POST';
    }
}
